export const SITUACAO_PLACA = {
  PERMITIR: '0',
  SOMENTE_TROCA_TITULARIDADE: '997',
  TROCA_TITULARIDADE_REATIVACAO: '998',
  RECUSADA: '999',
  NAO_PERMITIR: '1000',
  PERMITIR_COM_RESTRICAO: '1001',
};
